type Environment = "local" | "test" | "staging" | "production" | "uat";

interface ApiEnvironments {
  [key: string]: string;
}

// List of servers for each environment
const environments: ApiEnvironments = {
  local: "http://localhost:4000/API/",
  test: "https://testing-leen.kayan-healthcare.com/test/api/",
  staging: "https://staging-leen.kayan-healthcare.com/staging/api/",
  production: "https://prod-leen.kayan-healthcare.com/api/",
  // UAT: Use relative path - nginx will proxy to http://mc.qlm.com.qa/API/
  uat: "/api/"
};

export const getBaseUrl = (env: Environment): string => {
  return environments[env] || environments.local;
};

// Helper to detect environment automatically
export const getCurrentEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  
  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }
  
  // Check hostname for environment
  if (hostname === 'testing-leen.kayan-healthcare.com') {
    return 'test';
  }
  
  if (hostname === 'staging-leen.kayan-healthcare.com') {
    return 'staging';
  }
  
  if (hostname === 'prod-leen.kayan-healthcare.com') {
    return 'uat'; // Use UAT backend for prod-leen domain (external QLM server)
  }
  
  // UAT environment - connects to external QLM server
  if (hostname === 'uat-leen.kayan-healthcare.com') {
    return 'uat';
  }
  
  // Default to production if no specific hostname matches
  return 'production';
};

// Auto-detect and export current API base URL
export const API_BASE_URL = getBaseUrl(getCurrentEnvironment());